// extracted by mini-css-extract-plugin
module.exports = {"reminder":"ShippingRateField_reminder__Xh9vx"};